
import { Box } from "@chakra-ui/react";
import { SPACING } from "../generic/config";

const Divider = ({ vertical, mb }: { vertical?: boolean; mb?: number | string }) => {
    const h = <Box w={"100%"} my={mb ?? SPACING / 2} borderBottomWidth="1px" />;
    const v = <Box h={"100%"} mx={mb ?? SPACING / 2} borderLeftWidth="1px" />;

    return vertical ? v : h;
}

export default Divider;